import { createBitAttrs } from "../../internal";
const NAME = "label";
const PARTS = ["root"];
export const getAttrs = createBitAttrs(NAME, PARTS);
